import { render, staticRenderFns } from "./rule_detail.html?vue&type=template&id=3cb9792e&scoped=true&name=rule_detail&external"
import script from "./rule_detail.js?vue&type=script&lang=js&external"
export * from "./rule_detail.js?vue&type=script&lang=js&external"
import style0 from "./rule_detail.less?vue&type=style&index=0&id=3cb9792e&prod&scoped=true&lang=less&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cb9792e",
  null
  
)

export default component.exports